import React from 'react';
import { useState } from 'owa-react';
import isWin32StylingEnabled from 'owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled';

export const useCustomizerContextMenu = (): {
    contextMenuX: number | null;
    contextMenuY: number | null;
    handleContextMenu: React.MouseEventHandler<HTMLDivElement>;
    handleDismissContextMenu: () => void;
} => {
    const [contextMenuX, setContextMenuX] = useState<number | null>(null);
    const [contextMenuY, setContextMenuY] = useState<number | null>(null);

    const handleContextMenu: React.MouseEventHandler<HTMLDivElement> = React.useCallback(event => {
        if (isWin32StylingEnabled()) {
            // TODO: remove once customziation is implemented for Win32 styled ribbon
            // Work item: https://dev.azure.com/outlookweb/Outlook%20Web/_workitems/edit/456368/
            return;
        }
        event.preventDefault();
        setContextMenuX(event.clientX);
        setContextMenuY(event.clientY);
    }, []);

    const handleDismissContextMenu = React.useCallback(() => {
        setContextMenuX(null);
        setContextMenuY(null);
    }, []);

    return {
        contextMenuX,
        contextMenuY,
        handleContextMenu,
        handleDismissContextMenu,
    };
};
